import Http from './http';
import { personalTagCacheTTL } from 'Config';
import store from 'store';

class PersonalTagsService {
    constructor() {
        this.tags = null;
        // var intervalID = setInterval(()=>{
        //     this.resetCache()
        // }, personalTagCacheTTL);
    }

    resetCache(){
        store.set('tags', false);
        this.tags = null;
        this.getPersonalTags()
    }

    getPersonalTags() {
        return new Promise((resolve, reject) => {
            if (store.get('tags', false)){
                this.tags = store.get('tags');
            }
            if (this.tags) resolve(this.tags);
            else {
                Http.get('/users/personal-tags/').then(resp => {
                    this.tags = resp.data;
                    store.set('tags', this.tags);
                    resolve(resp.data);
                });
            }
        })
    }
}

export default new PersonalTagsService();


// WEBPACK FOOTER //
// ./src/services/Cache/micro-services/personalTags.js